import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PayloadService } from '../../services/payload.service';

interface DonazioniData {
  stripe?: {
    link?: string;
  };
  paypal?: {
    link?: string;
  };
  bonifico?: {
    iban?: string;
    intestatario?: string;
  };
  whatsapp?: {
    link?: string;
  };
}

@Component({
  selector: 'app-dona',
  imports: [CommonModule],
  templateUrl: './dona.component.html',
  styleUrl: './dona.component.scss',
})
export class DonaComponent implements OnInit {
  showBonifico = false;
  showWhatsapp = false;
  ibanCopied = false;
  donazioni: DonazioniData | null = null;

  constructor(private payloadService: PayloadService) {}

  ngOnInit(): void {
    this.payloadService.getDonazioni().subscribe({
      next: (data) => {
        this.donazioni = data;
      },
      error: (err) => {
        console.error('Errore nel caricamento delle donazioni:', err);
      },
    });
  }

  get hasStripe(): boolean {
    return !!this.donazioni?.stripe?.link;
  }

  get hasPaypal(): boolean {
    return !!this.donazioni?.paypal?.link;
  }

  get hasBonifico(): boolean {
    return !!this.donazioni?.bonifico?.iban;
  }

  get hasWhatsapp(): boolean {
    return !!this.donazioni?.whatsapp?.link;
  }

  get isAndroid(): boolean {
    return /android/i.test(navigator.userAgent);
  }

  toggleBonifico() {
    this.showBonifico = !this.showBonifico;
    if (this.showBonifico) this.showWhatsapp = false;
  }

  toggleWhatsapp() {
    this.showWhatsapp = !this.showWhatsapp;
    if (this.showWhatsapp) this.showBonifico = false;
  }

  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text);
    this.ibanCopied = true;

    setTimeout(() => {
      this.ibanCopied = false;
    }, 2000);
  }
}
